import Vue from 'vue'
import App from './App.vue'
import router from '../router/router'
import store from '../store'
import { Modal, Menu, ConfigProvider, message, notification, Carousel, Dropdown, Pagination, Empty, Spin, Icon, Input, Form, FormModel, Table, Select, Upload, Button, Checkbox, DatePicker, Progress, Tooltip, TimePicker, Slider, Radio, InputNumber, Popover, Row, Col, Tag } from "ant-design-vue";
import exportPDF from "../assets/js/htmlToPdf"
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import animated from 'animate.css'
VueViewer.setDefaults({
  title: false, // 隐藏标题
  toolbar: false, // 隐藏工具栏
  navbar: false, // 隐藏导航栏
})
Vue.use(animated);

Vue.use(Modal);
Vue.use(Menu);
Vue.use(Carousel);
Vue.use(Dropdown);
Vue.use(Pagination);
Vue.use(Empty);
Vue.use(Spin);
Vue.use(Icon);
Vue.use(ConfigProvider);
Vue.use(Input)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Table)
Vue.use(Select)
Vue.use(Upload)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Progress)
Vue.use(Tooltip)
Vue.use(exportPDF)
Vue.use(VueViewer)
Vue.use(Slider)
Vue.use(Radio)
Vue.use(InputNumber)
Vue.use(Popover)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tag)
Vue.config.productionTip = false

//注入全局属性$message
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
message.config({
  duration: 2,// 持续时间
  top: `5%`, // 到页面顶部距离
  maxCount: 3 // 最大显示数, 超过限制时，最早的消息会被自动关闭
})


import $ from 'jquery'
Vue.prototype.$ = $

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
